export default __webpack_public_path__ + "static/media/cineonstudioIconWhite.9b88541c.svg";